/**
 * SEO content – read more clamp + scroll reveal
 */
(function () {
  const SECTION_SELECTOR = '.seo-content[data-section-id]';

  function getCollapsedHeight(textEl, lines) {
    const style = window.getComputedStyle(textEl);
    const lineHeight = parseFloat(style.lineHeight);
    if (!lineHeight || Number.isNaN(lineHeight)) return textEl.scrollHeight;
    return Math.ceil(lineHeight * lines);
  }

  function initClamp(section) {
    const textEl = section.querySelector('[data-seo-text]');
    const toggle = section.querySelector('[data-seo-toggle]');
    if (!textEl || !toggle) return;

    const lines = parseInt(section.getAttribute('data-clamp-lines') || '5', 10);
    const readMore = toggle.textContent.trim();
    const readLess = section.getAttribute('data-read-less') || 'Read Less –';

    let expanded = false;
    let collapsedHeight = 0;
    let fullHeight = 0;

    function measure() {
      textEl.style.height = 'auto';
      fullHeight = textEl.scrollHeight;
      collapsedHeight = Math.min(fullHeight, getCollapsedHeight(textEl, lines));

      if (fullHeight <= collapsedHeight + 2) {
        toggle.hidden = true;
        textEl.style.height = 'auto';
        return;
      }

      toggle.hidden = false;
      textEl.style.height = expanded ? fullHeight + 'px' : collapsedHeight + 'px';
    }

    function setExpanded(next) {
      expanded = next;
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded ? readLess : readMore;
      textEl.style.height = expanded ? fullHeight + 'px' : collapsedHeight + 'px';
    }

    toggle.addEventListener('click', () => {
      if (!expanded) measure();
      setExpanded(!expanded);
    });

    measure();

    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => {
        if (!expanded) measure();
      });
      ro.observe(textEl);
    } else {
      window.addEventListener('resize', () => {
        if (!expanded) measure();
      });
    }
  }

  function initReveal(section, onVisible) {
    const callback = typeof onVisible === 'function' ? onVisible : null;

    if (!section.classList.contains('seo-content--reveal')) {
      section.classList.add('is-visible');
      if (callback) callback();
      return;
    }

    if (section.classList.contains('is-visible')) {
      if (callback) callback();
      return;
    }

    if (!('IntersectionObserver' in window)) {
      section.classList.add('is-visible');
      if (callback) callback();
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            section.classList.add('is-visible');
            if (callback) callback();
            observer.disconnect();
          }
        });
      },
      { rootMargin: '0px 0px -40px 0px', threshold: 0.05 }
    );

    observer.observe(section);

    // Fallback: ensure content is measurable/visible if observer never fires
    window.setTimeout(() => {
      if (!section.classList.contains('is-visible')) {
        section.classList.add('is-visible');
        if (callback) callback();
        observer.disconnect();
      }
    }, 1200);
  }

  function initSection(section) {
    if (section.dataset.seoReady === 'true') return;

    const readLessSetting = section.querySelector('[data-seo-toggle]');
    if (readLessSetting) {
      const schemaLess = section.getAttribute('data-read-less');
      if (schemaLess) section.dataset.readLess = schemaLess;
    }

    initReveal(section, () => initClamp(section));
    section.dataset.seoReady = 'true';
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section =
      event.target.querySelector(SECTION_SELECTOR) ||
      event.target.closest(SECTION_SELECTOR);
    if (section) {
      delete section.dataset.seoReady;
      initSection(section);
    }
  });
})();
